var map = {
	"./information.png": "5ce4",
	"./knowledgeBase.png": "9125",
	"./knowledgeTmp.png": "5fd3",
	"./otherTmp.png": "7087",
	"./serviceTmp.png": "5824",
	"./teamSystem.png": "3c44",
	"./teamTmp.png": "e6ce",
	"./trainingTmp.png": "d86e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3542";